import {Injectable, Inject} from 'ng-metadata/core';
import {getVid} from '../../../appConfig/appConfigForward';
import {getSearchScopesMap} from '../../../appConfig/appConfigForward';

const findKey= require('lodash/findKey');
const findIndex= require('lodash/findIndex');


@Injectable()
export class TabsAndScopesSelectorService {
    private scopesUrl;
    private _isRemoteTab: boolean= false;
    constructor(@Inject('$http') private $http : ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs) {
    }
    
    public updateScopes() {
        this.scopesUrl= this.restBaseURLs.scopeListBaseURL+'/'+getVid()+'/scopes';
        
        return this.$http({
                method: 'GET',
                url: this.scopesUrl,
                params:{}
            });
        
    }
    
    public findTabByScopeName(scopeName: string): string{
        let searchScopesMap: Object= getSearchScopesMap();
        return findKey(searchScopesMap, (scopes: [string])=> findIndex(scopes, (scope)=>scope['scope-id'] == scopeName) > -1);
    }
    
    public updateIsRemoteTab(tab: string){
        let searchScopesMap: Object= getSearchScopesMap();
        let scopes= searchScopesMap[tab];
        this._isRemoteTab= findIndex(scopes, (scope:{types: string})=>scope.types.includes('remote')) > -1;
    }
    
    get isRemoteTab(){
        return this._isRemoteTab;
    }
}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/tabsAndScopesSelector/tabsAndScopesSelector.service.ts